import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GatewayLogTimestampRange } from '../../utils/types';
import { GATEWAY_LOG_TIMESTAMP_RANGE_LABELS } from '../../utils/common/constants';

export type GatewayLogFilterParamsType = {
  filter: string;
  args?: object;
};

export type siteOptionType = {
  value: string | number;
  label: string;
  icon?: string;
};

export type timestampOptionType = {
  value: GatewayLogTimestampRange;
  label: string;
  icon?: string;
};

export interface LogsState {
  gatewayLogFilters: GatewayLogFilterParamsType[];
  selectedSite: siteOptionType;
  selectedTimestampRange: timestampOptionType;
  siteOptions: siteOptionType[];
  TimestampRangeOptions: timestampOptionType[];
}

export const DEFAULT_LOG_FILTERS: GatewayLogFilterParamsType[] = [
  { filter: 'defaultTrue' },
  { filter: 'user', args: { apply: true } },
  { filter: 'siteOnly', args: { apply: false } },
];

const initialState: LogsState = {
  gatewayLogFilters: DEFAULT_LOG_FILTERS,
  selectedSite: { value: 'All', label: 'All', icon: undefined },
  selectedTimestampRange: {
    value: GatewayLogTimestampRange.SESSION,
    label:
      GATEWAY_LOG_TIMESTAMP_RANGE_LABELS.get(GatewayLogTimestampRange.SESSION) ||
      String(GatewayLogTimestampRange.SESSION),
    icon: undefined,
  },
  siteOptions: [{ value: 'All', label: 'All', icon: undefined }],
  TimestampRangeOptions: Object.values(GatewayLogTimestampRange).map(
    (timestampRange) => ({
      value: timestampRange,
      label:
        GATEWAY_LOG_TIMESTAMP_RANGE_LABELS.get(timestampRange) || String(timestampRange),
      icon: undefined,
    }),
  ),
};

export const logsSlice = createSlice({
  name: 'logs',
  initialState: initialState,
  reducers: {
    setGatewayLogFilter: (
      state: LogsState,
      action: PayloadAction<GatewayLogFilterParamsType>,
    ) => {
      state.gatewayLogFilters = state.gatewayLogFilters.filter(
        (filterParams) => filterParams.filter !== action.payload.filter,
      );
      state.gatewayLogFilters.push(action.payload);
    },
    removeGatewayLogFilter: (state: LogsState, action: PayloadAction<string>) => {
      state.gatewayLogFilters = state.gatewayLogFilters.filter(
        (filterParams) => filterParams.filter !== action.payload,
      );
    },
    resetGatewayLogFilters: (state: LogsState) => {
      state.gatewayLogFilters = DEFAULT_LOG_FILTERS;
    },
    setSelectedSite: (state: LogsState, action: PayloadAction<siteOptionType>) => {
      state.selectedSite = action.payload;
    },
    setSelectedTimestampRange: (
      state: LogsState,
      action: PayloadAction<timestampOptionType>,
    ) => {
      state.selectedTimestampRange = action.payload;
    },
    setSiteOptions: (state: LogsState, action: PayloadAction<siteOptionType[]>) => {
      state.siteOptions = action.payload;
    },
  },
});

export const {
  setGatewayLogFilter,
  removeGatewayLogFilter,
  resetGatewayLogFilters,
  setSelectedSite,
  setSelectedTimestampRange,
  setSiteOptions,
} = logsSlice.actions;
export default logsSlice.reducer;
